<template>
  <div class="metafield-edit-image">
    <BasePictureInput
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      :hint="hint"
      :fieldKey="field.key"
      :scopeId="scopeId"
      @input="onInput"
    ></BasePictureInput>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  
  props: {
    field: Object,
    value: String,
    hint: String
  },

  computed: {
    scopeId () {
      return this.$store.getters[`${this.$route.meta.store}/id`]
    }
  },

  methods: {
    onInput (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
  .metafield-edit-image {
    
    p {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditImage.vue